/// From https://reactjsexample.com/responsive-tabs-with-react-js/
/// (https://maslianok.github.io/react-responsive-tabs/)
/// Licence: MIT
/// Not using the remove-tab facility atm
import React, { PureComponent } from 'react';

export interface TabProps {
  children?: JSX.Element;
  disabled?: boolean;
  /** aria-controls */
  panelId: string;
  selected: boolean;
  // refCallback(e: HTMLDivElement): HTMLDivElement;
  onClick?(originalKey: React.ReactText): void; /// or Promise
  /// Skip removability for now
  // onRemove: func,
  onFocus(originalKey: React.ReactText): (event: React.FocusEvent<HTMLDivElement>) => void;
  onBlur(): void;
  // allowRemove?: bool,
  id: string;
  originalKey: React.ReactText;
  classNames: string;
}

// const defaultProps = {
//     children: undefined,
//     // onRemove: () => {},
//     // allowRemove: false,
//     disabled: false
//   };

export class Tab extends PureComponent<TabProps> {
  tab: HTMLDivElement | null = null;
  /// As before, using PureComponent instead of calling shouldComponentUpdate directly
  // shouldComponentUpdate(nextProps: TabProps) {
  //     const { children, selected, classNames } = this.props;
  //     return children !== nextProps.children || selected !== nextProps.selected || classNames !== nextProps.classNames;
  // }
  // tab: HTMLDivElement | null;

  onTabClick = () => {
    const { onClick, originalKey, disabled } = this.props;
    // tslint:disable-next-line: no-unused-expression
    onClick && !disabled && onClick(originalKey);
  };

  //   renderRemovableTab = () => {
  //     const { children, onRemove } = this.props;
  //     return (
  //       <div className="removable">
  //         <div className="removable-text">{children}</div>
  //         <div className="removable-icon" onClick={onRemove}>
  //           x
  //         </div>
  //       </div>
  //     );
  //   };

  renderTab = () => {
    // const { children, allowRemove } = this.props;

    // if (allowRemove) {
    //   return this.renderRemovableTab();
    // }

    return this.props.children;
  };

  render = () => {
    const { id, classNames, selected, disabled, panelId, /*refCallback,*/ onFocus, onBlur, originalKey } = this.props;

    return (
      <div
        /// Set up a ref here to capture - essentially - the div offsetWidth value. This can be read (and stored) in
        /// turn by setting up another ref (NB NOT forwarded) on the Tab component itself, and reading it in the parent.
        /// This allows us to manage both the Inkbar and resizing efficiently.
        ref={e => (this.tab = e)}
        role="tab"
        className={classNames}
        id={id}
        aria-selected={selected ? 'true' : 'false'}
        aria-expanded={selected ? 'true' : 'false'}
        aria-disabled={disabled ? 'true' : 'false'}
        aria-controls={panelId}
        /// FIXME?
        tabIndex={0}
        onClick={this.onTabClick}
        onFocus={onFocus(originalKey)}
        onBlur={onBlur}
        // disabled={!!disabled}
      >
        {this.renderTab()}
      </div>
    );
  };
}

/// Typescript not PropTypes
// Tab.propTypes = {
//   children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
//   disabled: PropTypes.bool,

//   // generic props
//   panelId: PropTypes.string.isRequired,
//   selected: PropTypes.bool.isRequired,
//   onClick: PropTypes.func.isRequired,
//   onRemove: PropTypes.func,
//   onFocus: PropTypes.func.isRequired,
//   onBlur: PropTypes.func.isRequired,
//   allowRemove: PropTypes.bool,
//   id: PropTypes.string.isRequired,
//   originalKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
//   classNames: PropTypes.string.isRequired
// };

// Tab.defaultProps = {
//   children: undefined,
//   onRemove: () => {},
//   allowRemove: false,
//   disabled: false
// };



// WEBPACK FOOTER //
// ./src/admin/ui/components/tab/tab.tsx